"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _Configurator = _interopRequireDefault(require("./Configurator"));
var _optionActions = require("../../actions/optionActions");
var _settings = require("../../settings");
function mapStateToProps(state, ownProps) {
  (0, _settings.setSettings)(ownProps.settings); // ooh that's dirty

  return {
    optionIds: state.configurator.options.allIds
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      clearState: function clearState() {
        return dispatch((0, _optionActions.clearState)());
      },
      loadOptions: function loadOptions() {
        return dispatch((0, _optionActions.loadOptions)());
      }
    }
  };
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Configurator["default"]);
//# sourceMappingURL=redux.js.map